import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useServerConfigContext } from '@common/server-config-context/server-config-context';
import { ForbiddenPage } from './forbidden-page';
export function ConditionRestrictedPage({ condition, children, fallback }) {
    const serverConfig = useServerConfigContext();
    const isEnabled = useMemo(() => (serverConfig.isInitialized() ? condition(serverConfig) : false), [condition, serverConfig]);
    if (!isEnabled) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return _jsx(_Fragment, { children: fallback !== null && fallback !== void 0 ? fallback : _jsx(ForbiddenPage, {}) });
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return _jsx(_Fragment, { children: children });
}
